/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Modal, ModalFooter, Row } from "react-bootstrap";
import { Button, Input } from "../../../components";
import { useNavigate, useParams } from "react-router-dom";
import {
  DeactivateCoachBooking,
  GetCoachBookingDetails,
  GetSessionSoltsByGroup,
  PrintCoachBookingInvoice,
  PrintCoachBookingSummary,
  RefundCoachBooking,
} from "../../../utilities/api/coachingBooking";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { LableFromEnums } from "../../../utilities";
import { differenceInCalendarDays } from "date-fns";
import { toast } from "react-toastify";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.coachingSessionBooking;

export const CoachingBookingDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { Enums } = useAppSelector((state) => state.enumsArray);
  const { name } = useAppSelector((state) => state.verifiedUser.UserRole?.role);

  const [coachBookingData, setCoachBookingData] = useState<any>({});
  const [slots, setSlots] = useState<any>([]);
  const [openRemark, setShowRemark] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [refundModal, setRefundModal] = useState(false);
  const [remark, setRemark] = useState("");
  const [printing, setPrinting] = useState(false);
  const [printingSummary, setPrintingSummary] = useState(false);

  const [totalTax, setTotalTax] = useState(0);
  const [ratePerSession, setRatePerSession] = useState(0);
  const [ratePerWeek, setRatePerWeek] = useState(0);
  const [amount, setAmountData] = useState({}) as any;
  const [offerData, setOfferData] = useState({}) as any;
  const { AllFacilitiesData, errorMessage } = useAppSelector((state) => state.facilityList);
  const facilityAddress = AllFacilitiesData.find(
    (item: any) => item.name == coachBookingData.facilityName
  )?.address as string;

  useEffect(() => {
    getCoachBooking();
    getSessionSlots();
  }, []);

  if (errorMessage) {
    toast.error(errorMessage.message)
  }

  const getCoachBooking = () => {
    GetCoachBookingDetails(id)
      .then((response) => {
        const data = response?.data || {};
        setCoachBookingData({
          ...data,
        });

        const _ratePerSession = data?.ratePerSession;
        setRatePerSession(_ratePerSession);
        setRatePerWeek(_ratePerSession * data?.noOfDays);
        setOfferData({ discountPercent: data?.offerPercent });
        let getTotalTax = 0;

        data?.bookingTaxes.forEach((_tax: any) => {
          getTotalTax += _tax?.percentage;
        });

        setTotalTax(getTotalTax);
      })
      .catch((error) => toast.error(error.message));
  };
  const getSessionSlots = () => {
    GetSessionSoltsByGroup(id)
      .then((response) => {
        let data = [] as any;
        response.data.forEach((item: any) => {
          item.list.forEach((elem: any) => {
            data.push(elem);
          });
        });
        setSlots(data);
      })
      .catch((error) => toast.error(error.message));
  };
  const handleShow = () => setShowRemark(true);

  const handleClose = () => {
    setRemark("");
    setShowRemark(false);
  };

  const handleRefund = () => {
    setShowRemark(false);
    RefundCoachBooking(id, {

      remarkText: remark,
    })
      .then((res) => {
        toast.success(res?.data?.message);
        setRefundModal(false);
        getCoachBooking();
        getSessionSlots();

      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || getMessage.something_wrong);
      })
      .finally(() => {
        handleClose();
      });
  };

  const handleDeactivate = () => {
    setShowRemark(false);
    DeactivateCoachBooking(id, {
      remarkText: remark,
    })
      .then((res) => {
        toast.success(res?.data.message);
        setCancelModal(false);
        getCoachBooking();
        getSessionSlots();

      })
      .catch((err) => {
        toast.error(err?.response.data.message);
      })
      .finally(() => {
        handleClose();
      });
  };

  const handlePrint = () => {
    setPrinting(true);
    window.open(
      "/printing/?type=invoice&prefix=SB&id=" + coachBookingData.id + "&hash=" + coachBookingData.hash,
      "_blank"
    );
    setTimeout(() => {
      setPrinting(false);
    }, 2000);

  };
  const handlePrintSummary = () => {
    setPrintingSummary(true);
    window.open(
      "/printing/?type=summary&prefix=SB&id=" + coachBookingData.id + "&hash=" + coachBookingData.hash,
      "_blank"
    );
    setTimeout(() => {
      setPrintingSummary(false);
    }, 2000);

  };


  const _hasRefund = ["paid", "partially_paid"].includes(
    coachBookingData?.paymentStatus
  );


  const IsCancel =
    coachBookingData.paymentStatus === "pending" &&
    ["confirmed", "completed", "pending"].includes(coachBookingData.status);
  const IsRefund =
    ["paid", "partially_paid"].includes(coachBookingData.paymentStatus) &&
    ["confirmed", "completed", "pending", "cancelled"].includes(
      coachBookingData.status
    );
  const _hasCancelledBooking = coachBookingData?.status === "cancelled";
  const _hasRefunded = coachBookingData?.paymentStatus === "refunded";

  let refundData = {} as any;
  if (_hasRefunded) {
    refundData = coachBookingData?.bookingRemarks?.find?.(
      (_data: any) => _data?.remarkFor === "onRefundPayment"
    );
  }

  let deactivateData = null as any;
  if (_hasCancelledBooking) {
    deactivateData = coachBookingData?.bookingRemarks?.find?.(
      (_data: any) => _data?.remarkFor === "onDeactivateAttendee"
    );
  }

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="mb-0">
                Coaching Booking Details{" "}
              </Card.Title>
              <div>
                {!["END_USER", "OFFICE_ADMIN"].includes(name) && (
                  <>
                    <Button
                      type="button"
                      bname={"Initiate Refund"}
                      onClick={() => {
                        setRefundModal(true);
                      }}
                      name="deactive"
                      id="deactive"
                      className={
                        IsRefund
                          ? "btn btn-light rounded-1 me-3"
                          : "btn btn-light rounded-1 me-3 d-none"
                      }
                    ></Button>
                    <Button
                      type="button"
                      bname={"Cancel Booking"}
                      onClick={() => {
                        setCancelModal(true);
                      }}
                      name="deactive"
                      id="deactive"
                      className={
                        IsCancel
                          ? "btn btn-light rounded-1 me-3"
                          : "btn btn-light rounded-1 me-3 d-none"
                      }
                    ></Button>
                  </>
                )}

                {coachBookingData?.status === "completed" && (
                  <Button
                    type="button"
                    bname={
                      printing ? "Downloading Invoice" : "Download Invoice"
                    }
                    onClick={handlePrint}
                    name="print"
                    id="print"
                    className="btn btn-danger rounded-1 me-3"
                    disabled={printing}
                  ></Button>
                )}
                <Button
                  type="button"
                  bname={printing ? "Print Summary" : "Print Summary"}
                  onClick={handlePrintSummary}
                  name="print"
                  id="print"
                  className="btn btn-danger rounded-1"
                  disabled={printingSummary}
                ></Button>
              </div>
            </div>

            <hr />
            <Row>
              <Col lg={6}>
                <div className="coach-booking-details">
                  <Row className="text-start row-mb">
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Attendee Name
                      </span>
                      <span className="user-info">{`${coachBookingData?.attendee?.firstName} ${coachBookingData?.attendee?.lastName}`}</span>
                    </Col>
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Booking Status
                      </span>
                      <span className="user-info">
                        {LableFromEnums(coachBookingData?.status, Enums)}
                      </span>
                    </Col>
                  </Row>
                  <Row className="text-start row-mb">
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Contact Number
                      </span>
                      <span className="user-info">{`${coachBookingData?.user?.countryCode} ${coachBookingData?.user?.phone}`}</span>
                    </Col>
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Amount Status
                      </span>
                      <span className="user-info">
                        {LableFromEnums(coachBookingData?.paymentStatus, Enums)}
                      </span>
                    </Col>
                  </Row>
                  <Row className="text-start row-mb">
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Session Name
                      </span>
                      <span className="user-info">
                        {coachBookingData?.sessionName}
                      </span>
                    </Col>
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Sports Name{" "}
                      </span>
                      <span className="user-info">
                        {coachBookingData?.sportName}
                      </span>
                    </Col>
                  </Row>
                  <Row className="text-start row-mb">
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Enrolled Sessions
                      </span>
                      <span className="user-info">
                        {coachBookingData?.noOfSessionToAttend}
                      </span>
                    </Col>
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Expired Sessions
                      </span>
                      <span className="user-info">
                        {Number(coachBookingData?.noOfSessionToAttend) -
                          Number(coachBookingData?.remainingSessions)}
                      </span>
                    </Col>
                  </Row>
                  <Row className="text-start row-mb">
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Running Sessions
                      </span>
                      <span className="user-info">
                        {coachBookingData?.remainingSessions}
                      </span>
                    </Col>
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Coach Name
                      </span>
                      <span className="user-info">
                        {`${coachBookingData?.coach?.firstName} ${coachBookingData?.coach?.lastName}`}
                      </span>
                    </Col>
                  </Row>
                  <Row className="text-start row-mb">
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Court's Name
                      </span>
                      <span className="user-info">
                        {coachBookingData?.session?.sessionCourts?.map(
                          (item: any, index: number) =>
                            index !==
                              coachBookingData?.session?.sessionCourts?.length - 1
                              ? `${item?.court?.name}, `
                              : item?.court?.name
                        )}
                      </span>
                    </Col>
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Facility Name
                      </span>
                      <span className="fs-7 fw-semibold">
                        {coachBookingData?.facilityName}
                      </span>
                    </Col>
                  </Row>
                  <Row className="text-start row-mb">
                    <Col>
                      <span className="user-info-title text-info text-uppercase d-block mb-2">
                        Facility Address
                      </span>
                      <span className="user-info">{facilityAddress}</span>
                    </Col>
                    {_hasCancelledBooking && (
                      <Col>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          Booked Period
                        </span>
                        <span className="fs-7 fw-semibold">
                          {coachBookingData?.startDate} to{" "}
                          {coachBookingData?.endDate}
                        </span>
                      </Col>
                    )}
                  </Row>
                </div>
              </Col>
              <Col lg={6}>
                {!_hasCancelledBooking && (
                  <>
                    <div className="fw-semibold">
                      Booked Period:{" "}
                      <span className="fs-7 fw-semibold">
                        {coachBookingData?.startDate} to{" "}
                        {coachBookingData?.endDate}
                      </span>
                    </div>
                    <table className="table table-bordered table-sm ">
                      <thead>
                        <tr>
                          <th>Day</th>
                          <th>No. of Slot</th>
                          <th>Time</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {slots?.map((item: any, index: number) => {
                          return (
                            <tr key={"slots" + index}>
                              <td>{item.attendanceDay}</td>
                              <td>{item.noOfSlots}</td>
                              <td>
                                {item.startTime} to {item.endTime}
                              </td>
                              <td>
                                <span className="rupees-symbol">&#8377;</span>{" "}
                                {item.totalAmount?.toFixed(2)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </>
                )}
                {_hasRefunded && !deactivateData && (
                  <div className="coach-booking-details">
                    <Row className="text-start row-mb">
                      <span className="user-info-title text-info text-uppercase d-block">
                        Amount Refunded
                      </span>
                      <span className="user-info">
                        <span className="rupees-symbol">&#8377;</span>{" "}
                        {Math.round(
                          coachBookingData?.bookingPayments?.[0]?.payment
                            ?.paidAmount
                        )}{" "}
                      </span>
                    </Row>
                    <Row className="text-start row-mb">
                      <span className="user-info-title text-info text-uppercase d-block">
                        Date of Refund
                      </span>
                      <span className="user-info">{refundData?.createdAt}</span>
                    </Row>
                    <Row className="text-start row-mb">
                      <span className="user-info-title text-info text-uppercase d-block">
                        Refunded By
                      </span>
                      <span className="user-info">{`${coachBookingData?.updatedByUser?.firstName} ${coachBookingData?.updatedByUser?.lastName}`}</span>
                    </Row>
                    <Row className="text-start row-mb">
                      <span className="user-info-title text-info text-uppercase d-block">
                        Remarks for Refund
                      </span>
                      <span className="user-info">
                        {refundData?.remarkText}
                      </span>
                    </Row>
                  </div>
                )}
                {!!deactivateData && (
                  <div className="coach-booking-details">
                    <Row className="text-start row-mb">
                      <span className="user-info-title text-info text-uppercase d-block">
                        Date of Deactivation
                      </span>
                      <span className="user-info">
                        {deactivateData?.createdAt}
                      </span>
                    </Row>
                    <Row className="text-start row-mb">
                      <span className="user-info-title text-info text-uppercase d-block">
                        Deactivated By
                      </span>
                      <span className="user-info">{`${coachBookingData?.updatedByUser?.firstName} ${coachBookingData?.updatedByUser?.lastName}`}</span>
                    </Row>
                    <Row className="text-start row-mb">
                      <span className="user-info-title text-info text-uppercase d-block">
                        Remarks for Deactivation
                      </span>
                      <span className="user-info">
                        {deactivateData?.remarkText}
                      </span>
                    </Row>
                  </div>
                )}
              </Col>
            </Row>
            {!_hasRefunded && (
              <Row className="text-end">
                <hr />

                <Col md={{ span: 4, offset: 8 }} className="mb-3">
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Rate Per Session:{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {ratePerSession?.toFixed(2) || 0}
                  </span>
                </Col>
                <Col md={{ span: 4, offset: 8 }} className="mb-3">
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Selected Session Per week:{" "}
                  </span>
                  <span className="user-info">
                    {" "}
                    {coachBookingData?.noOfDays || 0}
                  </span>
                </Col>
                <Col md={{ span: 4, offset: 8 }} className="mb-3">
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Weekly Session Price:{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {ratePerWeek?.toFixed(2) || 0}
                  </span>
                </Col>
                <Col md={{ span: 4, offset: 8 }} className="mb-3">
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Weeks Enrolled:{" "}
                  </span>
                  <span className="user-info">
                    {" "}
                    {coachBookingData?.noOfWeeks || 0}
                  </span>
                </Col>
                <Col md={{ span: 4, offset: 8 }} className="mb-3">
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Sub Total:{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {coachBookingData?.subTotal?.toFixed(2)}
                  </span>
                </Col>
                {coachBookingData?.discount > 0 && (
                  <Col md={{ span: 4, offset: 8 }} className="mb-3">
                    <span className="user-info-title text-info text-uppercase mb-2">
                      Discount:{" "}
                    </span>
                    <span className="user-info">
                      -<span className="rupees-symbol">&#8377;</span>{" "}
                      {coachBookingData?.discount?.toFixed(2) || 0}
                    </span>
                  </Col>
                )}

                <Col md={{ span: 4, offset: 8 }} className="mb-3">
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Total Tax({totalTax}%) :{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {coachBookingData?.totalTax?.toFixed(2)}
                  </span>
                </Col>

                <Col md={{ span: 4, offset: 8 }} className="mb-3">
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Payable Amount :{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.round(coachBookingData?.totalAmount?.toFixed(2))}
                  </span>
                </Col>
                <Col md={{ span: 4, offset: 8 }} className="mb-3">
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Total Paid Amount :{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.round(coachBookingData?.totalPaidAmount)}
                  </span>
                </Col>
                {name !== "END_USER" && (
                  <Col md={{ span: 4, offset: 8 }} className="mb-3">
                    <span className="user-info-title text-info text-uppercase mb-2">
                      Balance Amount :{" "}
                    </span>
                    <span className="user-info">
                      <span className="rupees-symbol">&#8377;</span>{" "}
                      {Math.round(
                        coachBookingData?.totalAmount -
                        coachBookingData?.totalPaidAmount
                      ) || "0"}
                    </span>
                  </Col>
                )}
                <Col lg={12}>
                  <span className="d-block fst-italic fw-semibold mt-3">
                    <sup>*</sup>The Amount is inclusive of all the taxes
                  </span>
                </Col>
              </Row>
            )}
          </Card.Body>
        </Card>
      </Container>
      {refundModal && (
        <Modal show={refundModal} onHide={() => setRefundModal(false)} centered>
          <Modal.Header className="border-0 pb-0 pb-2" closeButton>
            <Modal.Title id="contained-modal-title-vcenter fw-semibold">
              Refund
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <label className="form-label">Remarks for Refund</label>
              <Input
                type="text"
                className="form-control"
                id="remark"
                name="remark"
                value={remark}
                onChange={(e: any) => setRemark(e?.target?.value)}
              />
            </div>
            <ModalFooter className="justify-center">
              <div className="">
                <Button
                  type="button"
                  bname="Confirm"
                  name="confirm"
                  id="confirm"
                  className="btn btn-primary rounded-1 mt-1"
                  onClick={handleRefund}
                ></Button>
              </div>
            </ModalFooter>
          </Modal.Body>
        </Modal>
      )}
      {cancelModal && (
        <Modal
          show={cancelModal}
          onHide={() => {
            setCancelModal(false);
          }}
          centered
        >
          <Modal.Header className="border-0 pb-0 pb-2" closeButton>
            <Modal.Title id="contained-modal-title-vcenter fw-semibold">
              Deactivate Booking
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <label className="form-label">Remarks for Deactivation</label>
              <Input
                type="text"
                className="form-control"
                id="remark"
                name="remark"
                value={remark}
                onChange={(e: any) => setRemark(e?.target?.value)}
              />
            </div>
            <ModalFooter className="justify-center">
              <div className="">
                <Button
                  type="button"
                  bname="Confirm"
                  name="confirm"
                  id="confirm"
                  className="btn btn-primary rounded-1 mt-1"
                  onClick={handleDeactivate}
                ></Button>
              </div>
            </ModalFooter>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};
